<template>
	<div class="container-fluid h-100 my-2">
		<div class="row justify-content-center align-items-center h-100">
			<div class="col-auto licence_choice">
				<router-link :to="{ name: 'displaySettings' }" class="d-block mb-3"><font-awesome-icon class="mr-1" :icon="['fal', 'arrow-left']"/> {{ $t('global.retour') }}</router-link>
				<div class="box" id="switch_tiers">

					<div class="text-center"><groomy-logo /></div>

					<div class="text-center mt-4 mb-5">
						<h2 class="mt-0 mb-1">{{ $t('compte.switch_tiers.select_tiers') }}</h2>
						<i>{{ $t('compte.switch_tiers.body') }}</i>
					</div>

					<ul>
						<li v-for="tiers in all_tiers" 
							:key="tiers.tiers_id"
							@click="chooseTiers(tiers.tiers_id)"
							class="licence_choice_card d-flex align-items-center"
						>
							<span>
								<b>{{ tiers.tiers_rs }}</b>
								<br/>
								<i>{{ tiers.tiers_postalcode }} {{ tiers.tiers_town }}</i>
							</span> 
							<font-awesome-icon class="ml-auto" :icon="['fal', 'angle-right']"/>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script type="text/javascript">
	import UserMixin from '@/mixins/User.js';
	import Config from '@/mixins/Config.js'

	export default {
		name: "SwitchTiers",
		mixins: [UserMixin, Config],
		data () {
			return {
				all_tiers: []
			}
		},
		mounted: async function() {
			this.init_component()
		},
		methods: {
            async init_component() {
            	this.all_tiers = this.getConfig('all_tiers')
            	if(!this.all_tiers) {
	            	this.all_tiers = await this.getTiersByUser()
            	}
            	this.setConfig('all_tiers', this.all_tiers)
            	if(this.all_tiers.length == 1) {
            		this.chooseTiers(this.all_tiers[0].tiers_id)
            	}
            },
            async chooseTiers(tiers_id) {
            	this.setConfig('tiers_id', tiers_id)
				const bearer = this.getConfig('token')
	 			this.request.set_headers(bearer, tiers_id)

	 			const redirect = this.defaultCaRedirect()
            	this.$router.push({
                    name: 'Loading',
                    query: {
                        redirect: redirect
                    }
                })
			}
		}
	}
</script>
